import { Component, HostBinding } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { delay } from "rxjs/operators";
import { SolveSubActivity } from "src/app/models";
import { AppStoreState } from "src/app/store";
import { addSubActivity } from "./store/actions";
import { selectSubActivities } from "./store/selectors";

@Component({
  selector: "app-solve-activity",
  templateUrl: "./solve-activity.component.html",
  styleUrls: ["./solve-activity.component.scss"],
})
export class SolveActivityComponent {
  constructor(private store$: Store<AppStoreState>) {}

  @HostBinding("class") class = "app-solve-activity";

  subActivities$: Observable<SolveSubActivity[]> = this.store$.pipe(
    select(selectSubActivities),
    delay(0)
  );

  addSolveSubActivity(): void {
    this.store$.dispatch(addSubActivity({ title: "Untitled Activity" }));
  }
}
